<div class="header-bg desktop-only">
  <div class="logo-img">
    <img src="../../../../assets/images/PuduvaiBazaar/puduvaibazaar-logo.png"  (click)="redirectToHome()" alt="">
  </div>



  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6" style="width: 70%;margin-top: 1%;">

        <div class="search-container position-relative">
          <form [formGroup]="searchForm" class="search-bar" style="width: 100%;">
            <input type="text" id="search-input" class="form-control search-input" placeholder="Search..."
              formControlName="search_term" (keyup)="onSearchChange()">
          </form>
          <i class="fas fa-search search-icon"></i>
          <ul id="search-list" class="list-group position-absolute mt-1 w-100"
            style="max-height: 200px; overflow-y: auto;" *ngIf="preList.length > 0" style="background-color: white;">
            <li *ngFor="let item of preList" style="color:black;    padding: 5px 5px;"
              (click)="navigationBasedOnSearch(item)">{{ item.name }}</li>
            <!-- List items will be dynamically added here -->
          </ul>
        </div>

      </div>
    </div>
  </div>

  <!-- <div class="search-bar" style="width: 100%;">
    <form [formGroup]="searchForm" class="search-bar">
      <i class="fa fa-search search-icon"></i>
      <input type="text" placeholder="Search" name="search" id="search" class="search-input"
        formControlName="search_term" (keyup)="onSearchChange()" (focusout)="clearResults()">
   
    </form>
  </div> -->
  <!-- <div class="search-results" *ngIf="preList.length > 0">
    <ul>
      <li *ngFor="let item of preList">{{ item.name }}</li>
    </ul>
  </div> -->


  <div class="user-icon">
    <a (click)="login()" style="text-decoration: none; cursor: pointer;">
      <p class="username" *ngIf="!userLoggedIn">Login</p>
    </a>

    <span class="d-flex" style="margin-right:12%;" *ngIf="userLoggedIn">
      <div class="dropdown">
        <a class="menu-title dropdown-toggle" type="button" id="dropdownMenuButton" (click)="toggleUserDropdown()"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
          style="text-decoration: none !important;color: #41403f !important;font-family: system-ui;">
          <span *ngIf="storedValue.userName.length<=7"
            class="lnr lnr-user" style="text-shadow: none;
                                                      font-family: sans-serif !important;
                                                      display: contents;
                                                      color: #ffffff!important;
                                                      text-align: center;
                                                      font-size: 15px;
                                                      font-weight: bold;">
            {{ storedValue.userName.substring(0,7) | titlecase }}
          </span>
          <span *ngIf="storedValue.userName.length>7"
          class="lnr lnr-user" style="text-shadow: none;
                                                    font-family: sans-serif !important;
                                                    display: contents;
                                                    color: #ffffff!important;
                                                    text-align: center;
                                                    font-size: 15px;
                                                    font-weight: bold;">
          {{ storedValue.userName.substring(0,7) | titlecase }}...
        </span>
        </a>
        <div id="dropdown" class="dropdown-menu" [class.show]="dropdownVisible"
          style="background-color: white!important;left: -75%;" aria-labelledby="dropdownMenuButton">
          <!-- <a class="logout-cutom dropdown-item" routerLink="my-account"
                  style="color: #6b6b6a!important; font-size: 11px;font-weight: bold;">My Account</a> -->
          <a class="logout-cutom dropdown-item" style="color: #6b6b6a!important; font-size: 11px;font-weight: bold;">My
            Account</a>
          <a class="logout-cutom dropdown-item" style="color: #6b6b6a!important;font-size: 11px;font-weight: bold;">My
            Order</a>
          <!-- <a class="logout-cutom dropdown-item" routerLink="my-orders"
                  style="color: #6b6b6a!important;font-size: 11px;font-weight: bold;">My Order</a> -->
          <!-- <a class="logout-cutom dropdown-item" (click)="logOut()"
                  style="color: #6b6b6a!important;font-size: 11px;font-weight: bold;cursor: pointer;">Logout</a> -->
          <a class="logout-cutom dropdown-item" (click)="logOut()"
            style="color: #6b6b6a!important;font-size: 11px;font-weight: bold;cursor: pointer;">Logout</a>
        </div>
      </div>
    </span>
    <img *ngIf="!userLoggedIn" src="../../../../assets/images/PuduvaiBazaar/user-icon.png" (click)="login()"
      alt="" srcset="" class="user-icon-image">


    <div class="cart-container">

      <li class="header-cart account-popup d-flex" style="position: relative;">
        <!-- Cart Icon with Item Count -->
        <a href="/cart" routerLink="/cart" style="text-decoration: none !important;">
          <span class="fa fa-shopping-cart cart-icon" style="font-size: 20px;">
            <!-- Badge showing number of items in cart -->
            <span class="cart-count">
              <span class="count-number">{{ this.cartProducts[0]?.total_items || 0}}</span>
            </span>
          </span>
        </a>

        <!-- Mini Cart Dropdown (Appears on Hover) -->

        <div class="min-cart-product-wrapper popup-content">

          <div class="row justify-content-center product-item" style="border-bottom: 2px dashed #f2f2f2; margin: 5px;"
            *ngFor="let item of cartProducts[0]?.products || []; let i = index">

            <div class="col-10">
              <h6>{{item.product_name}} </h6>
              <p style="font-size: small;">
                {{item.quantity}} <span style="font-size: smaller; padding-right: 5px;">⤬</span>{{item.price}}
              </p>
            </div>
            <div class="col-2">
              <p class="close" (click)="removeItem(i)">⤬</p>
            </div>
          </div>
          <div class="row" style="padding-top: 10px;">
            <div class="col-10">Total Items</div>
            <div class="col-2">
              <h6>{{ cartProducts[0]?.total_items || 0 }}</h6>
            </div>
          </div>

          <!-- Buttons for View Cart and Checkout -->
          <div class="text-center mr-2 mt-2">
            <div class="btn-group">
              <button  class="btn btn-secondary inq-btn-st" (click)="viewCart()" >View Cart</button>
              <button class="btn btn-primary inq-btn-st ml-1"
                [disabled]="!(appService.cartProducts.results.length > 0)">
                Checkout
              </button>
            </div>
          </div>
        </div>

      </li>


    </div>

  </div>

</div>


<div class="nav-bar desktop-only">
  <div class="nav-icon">
    <i class="fa-solid fa-bars"></i>
  </div>
  <div class="nav-menu">
    <ul>
      <li (click)="navigateToShop()" style="cursor: pointer;" >All</li>
      <!-- <li style="cursor: pointer;" (click)="navigateBasedOnCategory('Mobile')">Mobiles</li> -->
      <li  style="cursor: pointer;" (click)="navigateBasedOnCategory('Veg Starters')">Veg Starters</li>
      <!-- <li  style="cursor: pointer;" (click)="navigateBasedOnCategory('TV')">Led TV</li>
      <li  style="cursor: pointer;" (click)="navigateBasedOnCategory('Fashion')">Fashion</li>
      <li  style="cursor: pointer;" (click)="navigateBasedOnCategory('Furniture')">Furniture</li>
      <li  style="cursor: pointer;">Today's Deal</li> -->
    </ul>
  </div>
  <div class="history-coupons">
    <p style="cursor: pointer;">Browsing History</p>
    <p style="cursor: pointer;">Coupons</p>
  </div>
</div>

<div class="header-bg mobile-only">
  <div class="header-top">

    <div class="nav-icon" (click)="toggleNavMenu()">
      <i class="fa-solid fa-bars"></i>
    </div>

    <div class="logo-img">
      <img src="../../../../assets/images/PuduvaiBazaar/puduvaibazaar-logo.png" routerLink="/" alt="Logo">
    </div>


    <div class="user-icons">
      <div class="search-bar">
        <i class="fa fa-search search-icon" (click)="toggleSearchMenu()"></i>
        <div class="side-nav" [ngClass]="{'open': isSearchMenuOpen}">
          <i class="fa fa-search search-icon1" style="margin-left: 5%;margin-top: 3%;"></i>
          <input type="text" placeholder="Search" name="search" id="search" class="search-input">
          <i class="fa fa-times close-icon" (click)="toggleSearchMenu()"></i>
        </div>
      </div>
      <div class="user-icon">
        <!-- <p class="username">A N Other</p> -->
        <img src="../../../../assets/images/PuduvaiBazaar/user-icon.png" routerLink="/login" alt="User Icon"
          class="user-icon-image">
      </div>
      <a href="/cart" routerLink="/cart" style="text-decoration: none !important;">
      <span class="fa fa-shopping-cart cart-icon" style="font-size: 20px;">
        <!-- Badge showing number of items in cart -->
         
        <span class="cart-count">
          <span class="count-number">{{ cartProducts[0]?.total_items || 0 }}</span>
        </span>
      </span>
      </a>
    </div>
  </div>


  <div class="nav-menu" id="nav-menu">

    <ul>
      <li><i class="fa fa-times close-icon1" (click)="toggleNavMenu()"></i></li>
      <li routerLink="/Shops" (click)="toggleNavMenu()">All</li>
      <li routerLink="/Shops" (click)="toggleNavMenu()">Mobiles</li>
      <li routerLink="/Shops" (click)="toggleNavMenu()">Veg Starters</li>
      <li routerLink="/Shops" (click)="toggleNavMenu()">Fashion</li>
      <li routerLink="/Shops" (click)="toggleNavMenu()">Deals</li>
      <li routerLink="/Shops" (click)="toggleNavMenu()">Browsing History</li>
      <li routerLink="/Shops" (click)="toggleNavMenu()">Coupons</li>
    </ul>

  </div>

</div>